import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PaginationInfoPipe } from '../pipes/pagination-info.pipe';

@Component({
  selector: 'app-table-pagination-info',
  standalone: true,
  templateUrl: './table-pagination-info.component.html',
  styleUrls: ['./table-pagination-info.component.scss'],
  imports: [PaginationInfoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePaginationInfoComponent {
  @Input() itemsPerPage = 0;

  @Input() itemsTotalCount = 0;

  @Input() currentPageNumber = 1;
}
